import React from 'react';
import { Box, Heading, HStack } from '@hover/blueprint';
import { AppleStoreLogo, GooglePlayStoreLogo } from '../../../icons';

const HeroTablet: React.FC = () => (
  <Box
    d={{ base: 'flex', desktop: 'none' }}
    position="relative"
    flexDir="column"
    w="100%"
  >
    <Box
      px={{ base: 500, tablet: 800 }}
      pt={{ base: '50px', tablet: '75px' }}
      w="100%"
      bg="brandNavy.500"
      flexDir="column"
      borderBottomRightRadius={{ base: '150px', tablet: '300px' }}
      shadow="distance300"
    >
      <Heading maxW="2xl" size={{ base: 600, tablet: 700 }} color="neutral.0">
        Build your better tomorrow, today
      </Heading>
      <Heading
        maxW="2xl"
        pr={{ base: 0, tablet: 800 }}
        fontWeight={400}
        marginBottom={{ base: 0, tablet: 0 }}
        size={{ base: 300, tablet: 500 }}
        color="neutral.0"
        mb={{ base: 800, tablet: 500 }}
      >
        HOVER makes home improvement simpler, faster and more collaborative. It
        all starts with a 3D model of your home.
      </Heading>
      <HStack spacing="10px" mb="50px">
        <AppleStoreLogo />
        <GooglePlayStoreLogo />
      </HStack>
    </Box>
  </Box>
);

export default HeroTablet;
